import "./EditorSidePanel.scss";
import NodePalette from "./NodePallet/NodePalette";
import { Surface } from "@jsplumbtoolkit/browser-ui";

import { InspectorPanel } from "./Inspector/InspectorPanel";
import TestQuestView from "./TestMode/TestQuestView";

import { MultiSelectPanel } from "./MultiSelectPanel/MultiSelectPanel";
import { BrowserUIReact } from "@jsplumbtoolkit/browser-ui-react";
import { QuestInterface } from "@swivl/swivl-lib";

interface Props {
  toolkit: BrowserUIReact;
  canEdit:boolean 
  quest: QuestInterface;

  showControls: boolean;
  surface: Surface;
  selectedNode?: Node;
  selectedNodes: Node[];

  inTestMode: boolean;
  updateNode(node: Node, originalNode?: Node, forceRedraw?: boolean): void;
  deleteNodes(nodeOrNodes: Node | Node[]): void;
  saveQuest():void;
}

export function EditorSidePanel(props: Props) {
  const {
    showControls,
    quest,
    toolkit,
    surface,
    selectedNode,
    updateNode,
    deleteNodes,
    inTestMode,
    selectedNodes,
    canEdit
  } = props;

  return (
    <div className="EditorSidePanel" id="EditorSidePanel">
      {canEdit && showControls && (
        <NodePalette surface={surface} quest={quest} />
      )}
      <InspectorPanel 
        selectedNode={selectedNode}
        updateNode={updateNode}
        deleteNodes={deleteNodes}
        canEdit={canEdit}
      />
      {inTestMode && <TestQuestView selectedQuest={quest} />}
      {selectedNodes && selectedNodes.length > 1 && (
        <MultiSelectPanel
          saveQuest={props.saveQuest}
          toolkit={toolkit}
          quest={quest}
          deleteNodes={deleteNodes}
          selectedNodes={selectedNodes}
        />
      )}
    </div>
  );
}
